import {
  React,
  Component,
  axios,
  routes,
} from 'imports/CommonImports';

import {
  SecondaryButton,
} from 'imports/DesignImports';

import {
  LinearProgress,
  TextField,
} from 'material-ui';

const styles = {
  errorContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  container: {
    display: 'flex',
    padding: '0 2em',
  },
  dataContainer: {
    display: 'flex',
    marginRight: '2em',
    alignItems: 'center',
  },
  label: {
    width: '50%',
    fontWeight: '300',
  },
  latoFont: {
    fontFamily: 'Lato',
    fontWeight: '300',
  },
}

class IndicatorField extends Component {
  state = {
    loading: true,
    error: false,
    currentYear: (new Date(Date.now())).getFullYear(),
  }

  componentDidMount() {
    this.getIndicator();
  }

  render() {
    console.log(this.state.indicators);
    
    if(this.state.error){
      return(
        <div style={styles.errorContainer}>
          <p>No se pudieron encontrar los datos, por favor intenta nuevamente</p>
          <SecondaryButton label="Intenta nuevamente" onClick={this.getIndicator}/>
        </div>
      );
    }
    if(this.state.loading){
      return(<LinearProgress />);
    }
    return(
      <div style={styles.container}>
        {this.state.indicators.map((indicator, i) => {
          return(
            <div style={styles.dataContainer} key={indicator.id}>
              <h3 style={styles.label}>{indicator.name + ' (' + indicator.currency + ')'} {(new Date(indicator.date)).getFullYear()}:</h3>
                <TextField
                  id={'indicator-' + indicator.id}
                  underlineStyle={styles.underline}
                  inputStyle={{...styles.latoFont, ...{marginLeft: '1em'}}}
                  value={indicator.value}
                  onChange={(event, newValue) => this.handleChange(event, newValue, i)}
                  type='number'
                  disabled={this.props.disabled}
                  onBlur={(event) => this.sendIndicator(event, indicator)}
                />
            </div>
          );
        })}
      </div>
    )
  }

  handleChange = (event, newValue, position) => {
    let newState = this.state;
    newState.indicators[position].value = newValue;
    this.setState(newState);
    this.props.onChange(event, newValue, position)
  }

  sendIndicator = (event, indicator) => {
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ this.props.token},
    });
    connection.patch(routes.rawIndicator + '/' + indicator.id + '/', indicator)
    .then((response) => {
    })
    .catch((error) => {
      console.error(error);
    })
  }

  getIndicator = () => {
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ this.props.token}
    });
    connection.get(routes.indicator(this.props.projectId))
    .then((response) => {
      this.setState({
        indicators: response.data,
        loading: false,
        error: false,
      });
    })
    .catch((error) => {
      console.error(error);
      this.setState({
        loading: false,
        error: true,
      });
    })
  }

}

export default IndicatorField;



// WEBPACK FOOTER //
// ./src/components/files/IndicatorField.js